module.exports = __webpack_public_path__ + "static/ilustracao-gestor-tributario-2c0dea8d4e44deaf0ffb8c02347bc050.svg";